"use client";

import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

// React.CSSProperties (csstype) doesn't list `--*` custom properties on its
// inner `Properties` type, so widen with a typed intersection — keeps the
// rest of the style object strongly typed without an `as` escape hatch.
type CSSWithVars = React.CSSProperties & Record<`--${string}`, string | number>;

const TOASTER_STYLE: CSSWithVars = {
  fontFamily: "var(--font-peyda, PeydaWeb, system-ui, arial)",
  // Lift above vaul Drawer overlay+content (z-110) and Dialog (z-50) so toasts
  // surface on top of any open modal/drawer.
  "--toaster-z-index": "9999",
  zIndex: 9999,
};

// Dark-only app — the theme is pinned rather than read from a provider.
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      position="top-center"
      style={TOASTER_STYLE}
      toastOptions={{
        classNames: {
          toast:
            "group toast mx-auto w-[calc(100vw-2rem)] max-w-md group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-accent group-[.toast]:text-accent-foreground group-[.toast]:font-medium group-[.toast]:min-h-[44px] group-[.toast]:px-4",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
